/**
 *  会员优惠券操作接口
 */
import { axios } from '@/utils/request'

const subPath = '/membershipCoupon'

export default {
  useCoupon,
  recoverCoupon,
  queryLog
}

// 分页查询
function recoverCoupon (idOrCode) {
  return axios({
    url: `${subPath}/recover`,
    method: 'put',
    params: { couponNumbers: idOrCode }
  })
}

// 详情
function useCoupon (idOrCode, bookingNumber, usageTime) {
  return axios({
    url: `${subPath}/${idOrCode}/use`,
    method: 'put',
    params: { bookingNumber, usageTime }
  })
}

// 分页查询-优惠券使用日志
function queryLog (membershipId, parameter) {
  return axios({
    url: `${subPath}/${membershipId}/queryLog`,
    method: 'get',
    params: { ...parameter, 'page.curPage': parameter.curPage, 'page.pageSize': parameter.pageSize }
  })
}
